import { Box, RBox, Cyl } from './helpers';
import type { MatsProps } from './materials';

/** Twin rear doors on the cargo box: panels, seams, handles, hinges, bumper, tail lights. */
export function RearDoors({ mats }: MatsProps) {
  return (
    <group>
      {[0.31, -0.31].map((z) => (
        <RBox key={z} args={[0.028, 1.05, 0.6]} radius={0.025} smoothness={3} mat={mats.paint} pos={[-1.666, 1.13, z]} />
      ))}
      {/* seams */}
      <Box args={[0.014, 1.0, 0.016]} mat={mats.black} pos={[-1.682, 1.13, 0]} />
      <Box args={[0.014, 0.016, 1.2]} mat={mats.black} pos={[-1.682, 0.615, 0]} />
      <Box args={[0.014, 0.016, 1.2]} mat={mats.black} pos={[-1.682, 1.645, 0]} />
      {/* handles */}
      {[0.075, -0.075].map((z) => (
        <Box key={z} args={[0.032, 0.12, 0.024]} mat={mats.chrome} pos={[-1.692, 1.15, z]} />
      ))}
      {/* hinges */}
      {[0.85, 1.43].flatMap((y) =>
        [0.575, -0.575].map((z) => <Box key={`${y},${z}`} args={[0.03, 0.09, 0.036]} mat={mats.chrome} pos={[-1.692, y, z]} />),
      )}
      {/* rear bumper */}
      <Cyl args={[0.025, 0.025, 0.98, 12]} mat={mats.chrome} pos={[-1.72, 0.43, 0]} rot={[Math.PI / 2, 0, 0]} />
      {/* tail lights */}
      {[0.52, -0.52].map((z) => (
        <Box key={z} args={[0.03, 0.14, 0.07]} mat={mats.tail} pos={[-1.692, 0.66, z]} />
      ))}
    </group>
  );
}
